import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { AuthorizedService } from "shared/axios";

const END_POINT = "/worker";

export const useWorkerImpersonate = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (workerId: string) => {
      const response = await new AuthorizedService().post(
        `${END_POINT}/${workerId}/impersonate`,
        {}
      );
      return response.data;
    },
    onSuccess: (response: any) => {
      if (response?.token) {
        // Store the impersonation token temporarily in localStorage (shared between tabs)
        // This will be moved to sessionStorage when new tab is opened
        localStorage.setItem("tempImpersonateWorkerToken", response.token);

        const workerDashboardUrl = `${window.location.origin}/worker-order/all`;
        window.open(workerDashboardUrl, "_blank");

        message.success(t("worker:impersonateSuccess"));
      }
    },
    onError: () => {
      message.error(t("worker:impersonateFail"));
    },
  });
};

export const useHandleImpersonationToken = () => {
  return () => {
    // Check for temp impersonation token in localStorage (shared between tabs)
    const tempToken = localStorage.getItem("tempImpersonateWorkerToken");

    if (tempToken) {
      sessionStorage.setItem("impersonateWorkerToken", tempToken);

      localStorage.removeItem("tempImpersonateWorkerToken");
      window.location.reload();
      return true;
    }
    return false;
  };
};
